import { withStyles } from "@material-ui/core/styles";
import Slider from "@material-ui/core/Slider";

export const MpaSliderVertical = withStyles({
  "@global": {
    ".MuiSlider-root.MuiSlider-vertical": {
      padding: "0px",
      width: "100%",
      height: "80%"
    },
    ".MuiSlider-vertical .MuiSlider-rail": {
      width: "100%",
      height: "80%"
    },
    ".MuiSlider-vertical .MuiSlider-track": {
      width: "100%"
    },
    ".MuiSlider-vertical .MuiSlider-thumb": {
      marginLeft: "0px",
      marginBottom: "-2px"
    }
  },
  root: props => ({
    color: props.assignedcolor,
    top:"calc(6%)"
  }),
  thumb: {
    height: "3.5%",
    width: "100%",
    filter: "brightness(120%)",
    "&:focus,&:hover,&$active": {
      boxShadow: "inherit"
    },
    borderRadius: "0"
  },
  valueLabel: {
    left: "calc(35%)",
    top: -15,
    "& *": {
      background: "transparent",
      color: "ffffff",
      fontSize: "12pt",
      fontWeight: "bold"
    }
  },
  active: {},
  track: {
    filter: "brightness(60%)"
  },
  rail: {
    color: "transparent",
  }
})(Slider);

export const MpaSliderHorizontal = withStyles({
  "@global": {},
  root: props => ({
    color: props.assignedcolor,
    padding: "0px 0px",
    height:"70%",
    top:-4,
    left:3
  }),
  thumb: {
    height: "100%",
    width: "5%",
    filter: "brightness(120%)",
    "&:focus,&:hover,&$active": {
      boxShadow: "inherit"
    },
    borderRadius: "0",
    marginTop: "0px"
  },
  active: {},
  track: {
    height: "100%",
    filter: "brightness(60%)"
  },
  valueLabel: {
    left: "calc(-170%)",
    top: "calc(-35%)",
    "& *": {
      background: "transparent",
      color: "ffffff",
      fontWeight: "bold",
      fontSize:"1rem"
    }
  },
  rail: {
    color: "transparent",
    height: "100%"
  }
})(Slider);
